import { IApiSubetapa } from "../services/api.model";

export const APP_BASE_CONFIG = {
  epsg: 'EPSG:3857',
  extent: [-20026376.39, -20048966.10, 20026376.39, 20048966.10],
  geoServerOfertaLayers: 'MOE:MOE_OFERTA_SUPORTS_SERVEIS_VM',
  geoServerPreinscripcioLayers: 'MOE:MOE_ALL_ESTUDIS_VM',
  //geoServerServeisEducatiusLayers: 'MOE:MOE_SERVEIS_EDUCATIUS_VM',
  geoServerServeisEducatiusLayersTwo: 'MOE:MOE_SERVEIS_EDUCATIUS_VM_2',
  iccSourceUrl: 'http://b.tilemaps.icgc.cat/mapfactory/service?',
  iccSourceLayers: 'limits',
  municipisSourceUrl: 'http://geoserveis.icc.cat/icc_limadmin/wms/service?',
  municipisSourceLayers: '4,1,2',
  urlArcGIS: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer'
};

export const CENTRES: IApiSubetapa[] = [
  {
    id: null,
    literal: "Naturalesa del centre",
    codi: null,
    subnodes: [
      {
        id: '1',
        literal: "Centre públic",
        codi: "1",
        subnodes: [],
      },
      {
        id: '3',
        literal: "Centre privat amb ensenyaments concertats",
        codi: "3",
        subnodes: [],
      },
      {
        id: '2',
        literal: "Centre privat",
        codi: "2",
        subnodes: [],
      }
    ],
  },
];

export const TIPUS_SUPORT: IApiSubetapa[] = [
  {
    id: null,
    literal: "Centres amb suports addicionals i intensius d\'educació inclusiva",
    codi: null,
    subnodes: [
      {
        id: 'AIS',
        literal: "Centres amb Aula Integral de Suport (AIS)",
        codi: "AIS",
        subnodes: [],
      },
      {
        id: 'SIAL',
        literal: "Centres amb Suport Intensiu a l\'Audició i el Llenguatge (SIAL)",
        codi: "SIAL",
        subnodes: [],
      },
      {
        id: 'SIEI',
        literal: "Centres amb Suport Intensiu a l\'Escolarització Inclusiva (SIEI)",
        codi: "SIEI",
        subnodes: [],
      },
      {
        id: 'AACO',
        literal: "Centres amb Aula d\'Acollida",
        codi: "AACO",
        subnodes: [],
      },
      {
        id: 'CEEPSIR',
        literal: "Centres d\'Educació Especial Proveïdor de Serveis i Recursos (CEEPSIR)",
        codi: "CEEPSIR",
        subnodes: [],
      }
    ],
  },
];

export const CURS = [
  {
    id: 1,
    literal: "Centre públic del Servei d'Educació de Catalunya",
    codi: "45"
  },
  {
    id: 2,
    literal: "Centre privat del Servei d'Educació de Catalunya",
    codi: "46"
  },
  {
    id: 3,
    literal: "Centre privat",
    codi: "47"
  }
];

export const EDUCACIO_ESPECIAL = [
  {
    id: "educacioEspecial",
    literal: "Centre d'educació especial",
    codi: "1"
  }
];

export const SERVEIS_EDUCATIUS: IApiSubetapa[] = [
  {
    id: null,
    literal: "Serveis educatius de zona",
    codi: null,
    subnodes: [
      {
        id: 'CRP',
        literal: "CRP Centres de Recursos Pedagògics",
        codi: "CRP",
        subnodes: [],
      },
      {
        id: 'EAP',
        literal: "EAP Equips d\'Assessorament Psicopedagògic",
        codi: "EAP",
        subnodes: [],
      },
      {
        id: 'ELIC',
        literal: "ELIC Equips de Llengua, Interc. i Coh. Social",
        codi: "ELIC",
        subnodes: [],
      }
    ],
  },
  {
    id: null,
    literal: "Serveis educatius específics",
    codi: null,
    subnodes: [
      {
        id: 'CREDA',
        literal: "CREDA",
        codi: "CREDA",
        subnodes: [],
      },
      {
        id: 'CREDV',
        literal: "CREDV",
        codi: "CREDV",
        subnodes: [],
      },
      {
        id: 'CRETDIC',
        literal: "CRETDIC",
        codi: "CRETDIC",
        subnodes: [],
      },
    ],
  },
  {
    id: null,
    literal: "Altres serveis educatius",
    codi: null,
    subnodes: [
      {
        id: 'CESIRE',
        literal: "SE CESIRE (CRP espec. De suport a la innovació i la recerca educativa)",
        codi: "CESIRE",
        subnodes: [],
      },
      {
        id: 'CDA',
        literal: "CdA Camps d\'Aprenentatge",
        codi: "CDA",
        subnodes: [],
      },
    ],
  },
];